<template>
  <div>
    <div class="logo-wrapper">
      <Logo />
      <div class="hamburger-btn" @click="toggleMiniSidebar">
        <i class="fa fa-bars"></i>
      </div>
      <div class="back-btn" @click="toggle_sidebar">
        <i class="fa fa-angle-left"></i>
      </div>

    </div>
    <div class="logo-icon-wrapper">
      <router-link to="/">
        <img
          class="img-fluid"
          src="../../assets/images/logo/logo-icon.png"
          alt=""
      /></router-link>
    </div>
    <Nav v-if="!miniSidebar" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import Logo from './logo.vue';
  import Nav from './nav.vue';

  export default {
    name: 'Sidebar',
    components: {
      Logo,
      Nav,
    },
    computed: {
      ...mapState({
        miniSidebar: state => state.menu.miniSidebar
      })
    },
    methods: {
      toggle_sidebar() {
        this.$store.dispatch('menu/opensidebar');
        this.$store.state.menu.activeoverlay = false;
      },
      toggleMiniSidebar() {
        console.log("clicked");
        this.$store.dispatch('menu/toggleMiniSidebar');
      }
    },
  };
</script>
<style>
/* ================= MINI SIDEBAR ================= */

/* Sidebar width */
.page-wrapper .sidebar-wrapper {
  width: 260px;
}

.page-wrapper.mini-sidebar .sidebar-wrapper {
  width: 80px !important;
}

/* Hide menu text ONLY (not whole nav) */
.page-wrapper.mini-sidebar .sidebar-wrapper .nav-menu {
  display: none;
}

.page-wrapper .page-header {
  margin-left: 260px;
}

/* MINI MODE */
.page-wrapper.mini-sidebar .page-header {
  margin-left: 80px !important;
  width: calc(100% - 80px) !important;
}

/* Body adjustment */
.page-wrapper .page-body {
  margin-left: 260px;
}

.page-wrapper.mini-sidebar .page-body {
  margin-left: 0px !important;
}

.page-wrapper .logo-wrapper {
  display: flex;
  justify-content: center;
}

/* Center logo area */
.page-wrapper.mini-sidebar .logo-wrapper {
  justify-content: center;
}

.page-wrapper.mini-sidebar .logo-wrapper a {
  display: none !important;
}

/* Hamburger */
.hamburger-btn {
  cursor: pointer;
  margin-left: auto;
  font-size: 18px;
  color: #143D60;
}

</style>
